import React, { useEffect, useState } from "react";
import Styles from './styles.module.scss';
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { GoogleOAuthProvider } from '@react-oauth/google';
// import 'react-toastify/dist/ReactToastify.css';
import { Route, Routes, Outlet } from "react-router-dom";
import { TonConnectUIProvider } from '@tonconnect/ui-react';
import MainPage from "../../pages/mainPage";
import { useDispatch, useSelector } from "react-redux";
import WebApp from "@twa-dev/sdk";
import {setTelegramStatus} from "../../store/main/action";
// import DebugBtn from "../debugBtn";
import { getUserData } from "../../store/cabinet/action";
import PublicHeader from "../publicHeader";
import PublicFooter from "../publicFooter";
import HowItWorksPage from "../../pages/howItWorksPage";
import CabinetMatrixPage from "../../pages/cabinetMatrixPage";
import CabinetNavigation from "../cabinetNavigation";
import CabinetHeader from "../cabinetHeader";
import CabinetRoadmapPage from "../../pages/cabinetRoadmapPage";
import CabinetLeaderboardPage from "../../pages/cabinetLeaderboardPage";
import CabinetReferralPage from "../../pages/cabinetReferralPage";
import CabinetContestsPage from "../../pages/cabinetContestsPage";
import LogPage from "../../pages/logPage";
import RegPage from "../../pages/regPage";
import ResPage from "../../pages/resPage";
import CabinetSettingsPage from "../../pages/cabinetSettingsPage";
import {TonConnect} from "@tonconnect/sdk";
import DebugBtn from "../debugBtn";
import CabinetTransactionsPage from "../../pages/cabinetTransactionsPage";
import CabinetEventsPage from "../../pages/cabinetEventsPage";
// import EventPage from "../../pages/eventPage";
// import CabinetMainPage from "../../pages/cabinetMainPage";
// import StorePage from "../../pages/storePage";

const MainLayout = () => (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_ID}>
        <div className={`${Styles.main} ${window.location.pathname.indexOf('how-it-works') === 1 ? Styles.mainGod : null}`}>
            <PublicHeader />
            <Outlet />
            <PublicFooter />
            <DebugBtn/>
        </div>
    </GoogleOAuthProvider>
);

const CabinetLayout = () => (
    <div className={`${Styles.cabinet}`}>
        <div className={`${Styles.posWrap}`}>
            <CabinetHeader />
            <div className={`${Styles.cabinetWrap} ${Styles.pageContainer}`}>
                <CabinetNavigation />
                <Outlet />
                <ToastContainer/>
            </div>
        </div>
    </div>
);

const App = () => {
    const dispatch = useDispatch();
    const authStatus = useSelector(store => store.main.authorizationStatus);
    const isTelegram = useSelector(store => store.main.isTelegram);
    const [isTonConnectAvailable, setIsTonConnectAvailable] = useState(true);

    console.log(isTonConnectAvailable);

    useEffect(() => {
        dispatch(setTelegramStatus(!!window.Telegram && !!WebApp.initData));
    }, [dispatch, isTelegram]);


    useEffect(() => {
        if (authStatus) {
            dispatch(getUserData());
        }
    }, [authStatus, dispatch]);

    useEffect(() => {
        const checkManifest = async () => {
            try {
                const response = await fetch(`${window.location.origin}/tonconnect-manifest.json`);
                if (!response.ok) throw new Error(`Ошибка загрузки: ${response.statusText}`);
                await response.json(); // Проверяем JSON
                console.log("✅ TonConnect manifest загружен");
            } catch (error) {
                console.error("❌ Ошибка TonConnect:", error);
                setIsTonConnectAvailable(false); // Отключаем TonConnect
            }
        };
        checkManifest();
    }, []);

    // useEffect(() => {
    //     const urlParams = new URLSearchParams(window.location.search);
    //     console.log(`Debug Mode: ${urlParams.get("debug")}`);
    // }, []);

    useEffect(() => {
        new TonConnect({manifestUrl: `${window.location.origin}/tonconnect-manifest.json`}).restoreConnection();
    }, []);

    return  (
        <TonConnectUIProvider
            manifestUrl={`${window.location.origin}/tonconnect-manifest.json`}
            options={{
                bridgeUrl: "https://ton-connect-bridge.bgwapi.io/bridge",
            }}
        >
            <section className={Styles.container}>
                <Routes>
                    <Route element={<MainLayout />}>
                        <Route exact path="/" element={<MainPage />} />
                        <Route exact path="/how-it-works" element={<HowItWorksPage />} />
                        <Route exact path="/sign-in" element={<LogPage />} />
                        <Route exact path="/sign-up" element={<RegPage />} />
                        <Route exact path='/sign-up/ref/:code' element={<RegPage/>}/>
                        <Route exact path="/reset-password" element={<ResPage />} />
                        {/*<Route exact path="/event" element={<EventPage />} />*/}
                        {/*<Route exact path="/main" element={<CabinetMainPage />} />*/}
                        {/*<Route exact path="/store" element={<StorePage />} />*/}
                    </Route>
                    <Route element={<CabinetLayout />}>
                        <Route exact path="/matrix" element={<CabinetMatrixPage/>}/>
                        <Route exact path="/roadmap" element={<CabinetRoadmapPage/>}/>
                        <Route exact path="/leaderboard" element={<CabinetLeaderboardPage/>}/>
                        <Route exact path="/referral-program" element={<CabinetReferralPage/>}/>
                        <Route exact path="/contests" element={<CabinetContestsPage/>}/>
                        <Route exact path="/settings" element={<CabinetSettingsPage/>}/>
                        <Route exact path="/transactions" element={<CabinetTransactionsPage/>}/>
                        <Route exact path="/events" element={<CabinetEventsPage/>}/>
                    </Route>
                </Routes>
            </section>
        </TonConnectUIProvider>

    );
};

export default App;
